module.exports = __webpack_public_path__ + "img/img36.baecb6eb.png";